import { TApplicationState } from '../../types/redux';

export function getSellers(state: TApplicationState) {
  const {
    newbuilding: { sellers },
  } = state;

  if (sellers) {
    return sellers;
  }

  return [];
}
